export default [
    {
        key: "forwardhead",
        name: "頭前傾",
        definition: {
            name: "定義",
            list: ["頭前傾指人體處於自然站姿、坐姿時，頭相對於軀幹處於異常前傾位。常見於久坐的學生、辦公室人群。"]
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、長期伏案。工作長時間對著電腦習慣性的出現頭部往前伸。",
                "2、習慣性低頭看手機。低頭看手機，即所謂的‘低頭族’也是導致頭部前傾的主要誘發原因。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、頭暈頭痛：頭部前傾可能影響頭部血液循環，由於血流不暢而導致頭部缺氧，引發頭暈頭痛。",
                "2、頸椎病：由於頭部異位導致頸部軟組織、骨骼的異常，增大了頸椎病患病風險。",
                "3、心腦血管疾病：頭部的異位可能影響頭部血液循環，危害心腦血管健康。",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "頭側傾",
        definition: {
            name: "定義",
            list: ["頭側傾指人體處於自然站姿、坐姿時，頭過度偏向單側的異常姿態。主要誘因是左右兩側肩頸肌肉力量失衡，多由於習慣性的錯誤姿勢導致。"]
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、習慣性使用單側肩頸部肌肉：坐、臥時，頸部多只單向一邊側，造成左右兩側肩頸肌力不平衡。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、肌肉韌帶慢性勞損：長期頭側傾容易導致頸後韌帶以及肌肉韌帶慢性勞損。",
                "2、頸椎病：由於頭部異位導致頸部軟組織、骨骼的異常，增大了頸椎病患病風險。",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "高低肩",
        definition: {
            name: "定義",
            list: ["高低肩指左右兩側肩部在人體自然放鬆狀態下、豎直高度不一致的情況。通常高低肩多伴隨脊柱姿態的異常。"]
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、單側受力過重：例如長期單側背包或提重物。",
                "2、長期錯誤坐姿：翹二郎腿久坐、伏案工作時趴桌等不良習慣導致。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、腰痛：（高低肩）可能造成骨盆的移位，使腰部左右兩側肌力不平衡，導致腰痛。",
                "2、骨刺：高低肩使頸椎受力異常，最後可能導致頸椎部位退化，易形成骨刺。",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "圓肩",
        definition: {
            name: "定義",
            list: ["圓肩，指從側面觀察人體，肩部呈現向前、向內收的狀態。多伴隨駝背。常見於學生、辦公室工作人群。"],
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、習慣性姿態不佳：如含胸駝背，不規範的側臥，側躺等。",
                "2、胸背部肌肉力量不平衡：胸大肌相對背部肌肉力量薄弱。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、心臟負擔加重：過度圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈被壓迫，使心臟工作負擔加重。",
                "2、神經被壓迫：肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起頭痛、手臂麻木。",
            ],
        }
    },
    {
        name: "脊柱側彎",
        key: "scoliosis",
        definition: {
            name: "定義",
            list: ["脊柱位置出現異常，通過影像檢查，可能發現脊柱側彎等脊柱非正直狀態。異常可分為先天及後天性。後天性異常與習慣性姿態錯誤有關。"],
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、單側受力過重：例如長期單側背包或提重物。",
                "2、長期錯誤坐姿：翹二郎腿久坐、伏案工作時趴桌等不良習慣導致。",
                "3、先天原因：由先天性導致的脊柱側彎。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、腰椎間盤突出。",
                "2、腰痛：可能造成骨盆的移位，使腰部左右兩側肌力不平衡，導致腰痛。",
                "3、長短腿。",
            ],
        }
    },
    {
        name: "骨盆側傾",
        key: "unevenhip",
        definition: {
            name: "定義",
            list: ["骨盆側傾指左右兩側髖部高度差異較大，呈現骨盆歪斜的狀態。多伴隨脊柱位置異常、高低肩。"],
        },
        triggerreason: {
            name: "引发原因",
            list: [
                "1、長期錯誤坐姿：翹二郎腿久坐、伏案工作時趴桌等不良習慣導致。",
                "2、先天性長短腿：由於先天性長短腿而導致的骨盆側傾。",
                "3、兩側下肢體態不平衡：例如，一隻腳有扁平足而另一隻沒有，或程度不相同；兩側均有膝超伸現象，但程度不同。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、腰椎間盤突出。",
                "2、慢性疼痛：骨盆側傾可能會引發腰腿疼痛、肩頸疼痛。",
                "3、長短腿。",
            ],
        }
    },
    {
        name: "O 型腿",
        key: "oleg",
        definition: {
            name: "定義",
            list: ["人體正常姿態站立，兩腳併攏時內側腳踝可貼緊而雙膝內側無法貼緊、甚至縫隙很大，腿間呈現“O”形狀。此類腿型與日常姿態習慣有關，少兒出現 O 型腿也可能與佝僂病有關。"],
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、習慣性不良姿勢如：骨盆後傾、足內翻傾向。",
                "2、肌肉力量不平衡如：髖外旋肌過緊。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、內側半月板損傷：O 型腿造成下肢力線發生改變，膝關節內側間隙承受大於正常負荷的壓力。可能引起膝關節內側半月板損傷。",
                "2、關節炎：嚴重（O 型腿）最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節置換手術。",
            ],
        }
    },
    {
        name: "X 型腿",
        key: "xleg",
        definition: {
            name: "定義",
            list: "人體正常姿態站立，雙腿併攏時內側膝可貼緊而兩側腳踝內側無法貼緊、甚至縫隙很大，腿間呈現‘X’形狀。此類腿型與日常姿態習慣、肌力失衡有關。",
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1、習慣性不良姿勢如：骨盆前傾、足外翻傾向。",
                "2、肌肉力量不平衡如：髖內旋肌過緊。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1、外側半月板損傷：X 型腿造成下肢力線發生改變，膝關節外側間隙承受大於正常負荷的壓力。可能引起膝關節外側半月板損傷。",
                "2、關節炎：嚴重（X 型腿）最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節置換手術。",
            ],
        }
    },
    {
        name: "膝過伸",
        key: "kneehyperextension",
        definition: {
            name: "定義",
            list: ["膝過伸，也稱‘膝反弓’。從人體側面觀，可見腿部呈現出向後側彎曲、膝蓋內凹、小腿相較大腿過度前伸。此種體態常見於芭蕾舞演員、以及大腿肌力薄弱者。"],
        },
        triggerreason: {
            name: "引發原因",
            list: [
                "1. 錯誤的發力姿勢：站立時主要重量落在前腳掌。",
                "2. 足底筋膜緊張：可能由於長期穿高跟鞋導致。",
                "3. 膝關節周圍肌肉力量薄弱、大腿前後側肌力不足。",
            ]
        },
        danger: {
            name: "危害",
            list: [
                "1. 膝關節畸形：長期膝關節過伸，可導致骨關節退變的發生率明顯升高，會引起膝關節的過度磨損，造成關節畸形。",
                "2. 全身平衡受損：髖、膝、踝三關節之間有著很大的位置、功能聯繫，膝關節位置的改變會影響其下方的踝關節位置與上方的髖關節、骨盆的位置，逐漸損害全身的平衡狀態，長期會引發各種疼痛。",
            ],
        }
    },
]